async function initImageSliders(container = document) {
  const allSLiders = container.querySelectorAll('.content-image-slider');
  if (!allSLiders.length) return;

  const { default: Splide } = await import('@splidejs/splide');

  allSLiders.forEach((slider) => {
    const main = new Splide(slider, {
      perPage: 1,
      rewind: true,
      pagination: false,
      gap: 16,
      arrows: true,
      updateOnMove: true,
      // type: 'loop',
    })

    const counterCurrentEl = slider.querySelector('.image-slider__current');

    // Event listener for slide change
    main.on('move', (newIndex, oldIndex) => {
      counterCurrentEl.textContent = newIndex + 1; // Update the counter display
    });


    const thumbnails = new Splide(slider.nextElementSibling, {
      rewind: true,
      fixedWidth: 177,
      fixedHeight: 97,
      focus: 'center',
      isNavigation: true,
      arrows: false,
      gap: 15,
      // focus: 'center',
      pagination: false,
      updateOnMove: true,
      dragMinThreshold: {
        mouse: 4,
        touch: 10,
      },
      breakpoints: {
        1024: {
          gap: 8,
          fixedWidth: 167,
          fixedHeight: 93,
        },
      },
    });

    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();

    // const currentField = slider.querySelector('.image-slider__current');
    // const total = slider.querySelector('.image-slider__total');
    // const arrows = slider.querySelectorAll('.image-slider__arrow');

    // const initCounter = () => {
    //   currentField.textContent = generatedSlider.index + 1;
    //   total.textContent = generatedSlider.length;
    // }

    // initCounter();
    // arrows.forEach(item => {
    //   item.addEventListener('click', initCounter);
    // })
  })
}

document.addEventListener('DOMContentLoaded', () => initImageSliders(document));
window.initImageSliders = initImageSliders;